<template>
  <div class="bg-empty" :class="[`size-${size}`, { 'has-action': showAction }]">
    <div class="empty-icon">
      <i :class="iconClass"></i>
    </div>
    <div class="empty-text">{{ description }}</div>
    <div v-if="hint" class="empty-hint">{{ hint }}</div>
    <div v-if="showAction" class="empty-action">
      <el-button :type="actionType" :icon="actionIcon" @click="handleAction">
        {{ actionText }}
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BgEmpty',
  props: {
    // 图标类名
    icon: {
      type: String,
      default: 'el-icon-box'
    },
    // 描述文字
    description: {
      type: String,
      default: '暂无数据'
    },
    // 提示文字
    hint: {
      type: String,
      default: ''
    },
    // 尺寸: small, medium, large
    size: {
      type: String,
      default: 'medium'
    },
    // 是否显示操作按钮
    showAction: {
      type: Boolean,
      default: false
    },
    // 操作按钮文字
    actionText: {
      type: String,
      default: '立即创建'
    },
    // 操作按钮类型
    actionType: {
      type: String,
      default: 'primary'
    },
    // 操作按钮图标
    actionIcon: {
      type: String,
      default: 'el-icon-plus'
    }
  },
  computed: {
    iconClass () {
      return this.icon
    }
  },
  methods: {
    handleAction () {
      this.$emit('action')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.bg-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: $spacing-xxl;
  text-align: center;

  .empty-icon {
    color: var(--text-placeholder);
    margin-bottom: $spacing-md;

    i {
      font-size: 64px;
    }
  }

  .empty-text {
    font-size: $font-size-md;
    color: var(--text-regular);
    font-weight: 500;
    margin-bottom: $spacing-sm;
  }

  .empty-hint {
    font-size: $font-size-sm;
    color: var(--text-secondary);
    margin-bottom: $spacing-lg;
  }

  .empty-action {
    margin-top: $spacing-md;
  }

  // 尺寸变体
  &.size-small {
    padding: $spacing-lg;

    .empty-icon i {
      font-size: 40px;
    }

    .empty-text {
      font-size: $font-size-base;
    }

    .empty-hint {
      font-size: $font-size-xs;
    }
  }

  &.size-large {
    padding: 64px;

    .empty-icon i {
      font-size: 80px;
    }

    .empty-text {
      font-size: $font-size-lg;
    }

    .empty-hint {
      font-size: $font-size-base;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/BgEmpty.vue